export const UNSAVED_CHANGES_WARNING = t('Do you want to leave without saving?')
